module.exports = __webpack_public_path__ + "static/regtech-sm-fe608ef4f6b9d42517d4d3f0a6eccd81.jpg";